interface IProps {
  onExit: () => void
  children: JSX.Element
}

export default function BottomPopUp({ children, onExit }: IProps) {
  return (
    <div className="h-view fixed z-50 bottom-0 left-0 bg-black bg-opacity-50 w-full flex flex-col justify-end pop-up-bottom">
      <div className="flex-1" onClick={onExit} />
      <footer className="bg-white rounded-t-3xl p-6 pt-10 relative flex justify-center" style={{ maxHeight: '83%' }}>
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute top-4 right-4 cursor-pointer" onClick={onExit}>
          <path d="M1.51172 0.113281L7 5.60156L12.4883 0.113281L13.3867 1.01172L7.89844 6.5L13.3867 11.9883L12.4883 12.8867L7 7.39844L1.51172 12.8867L0.613281 11.9883L6.10156 6.5L0.613281 1.01172L1.51172 0.113281Z" fill="currentColor" />
        </svg>
        <div className="h-full w-full flex flex-col items-center overflow-y-auto">
          {children}
        </div>
      </footer>
    </div>
  )
}